"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Layer = _interopRequireDefault(require("../Layer.js"));

var _Event = _interopRequireDefault(require("../../render/Event.js"));

var _EventType = _interopRequireDefault(require("../../render/EventType.js"));

var _transform = require("../../transform.js");

var _color = require("../../color.js");

var _extent = require("../../extent.js");

var _dom = require("../../dom.js");

var _array = require("../../array.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/renderer/canvas/Layer
 */


/**
 * @type {CanvasRenderingContext2D}
 */
var pixelContext = null;

function createPixelContext() {
  var canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;
  pixelContext = canvas.getContext('2d');
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */


var CanvasLayerRenderer =
/** @class */
function (_super) {
  __extends(CanvasLayerRenderer, _super);
  /**
   * @param {LayerType} layer Layer.
   */


  function CanvasLayerRenderer(layer) {
    var _this = _super.call(this, layer) || this;
    /**
     * @protected
     * @type {HTMLElement}
     */


    _this.container = null;
    /**
     * @protected
     * @type {number}
     */

    _this.renderedResolution;
    /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */

    _this.tempTransform = (0, _transform.create)();
    /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */

    _this.pixelTransform = (0, _transform.create)();
    /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */

    _this.inversePixelTransform = (0, _transform.create)();
    /**
     * @type {CanvasRenderingContext2D}
     */

    _this.context = null;
    /**
     * @type {boolean}
     */

    _this.containerReused = false;
    /**
     * @private
     * @type {CanvasRenderingContext2D}
     */

    _this.pixelContext_ = null;
    /**
     * @protected
     * @type {import("../../PluggableMap.js").FrameState|null}
     */

    _this.frameState = null;
    return _this;
  }
  /**
   * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */


  CanvasLayerRenderer.prototype.getImageData = function (image, col, row) {
    if (!pixelContext) {
      createPixelContext();
    }

    pixelContext.clearRect(0, 0, 1, 1);
    var data;

    try {
      pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
      data = pixelContext.getImageData(0, 0, 1, 1).data;
    } catch (err) {
      return null;
    }

    return data;
  };
  /**
   * @param {import('../../PluggableMap.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */


  CanvasLayerRenderer.prototype.getBackground = function (frameState) {
    var layer = this.getLayer();
    var background = layer.getBackground();

    if (typeof background === 'function') {
      background = background(frameState.viewState.resolution);
    }

    return background || undefined;
  };
  /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {number} opacity Opacity.
   * @param {string} [opt_backgroundColor] Background color.
   */


  CanvasLayerRenderer.prototype.useContainer = function (target, transform, opacity, opt_backgroundColor) {
    var layerClassName = this.getLayer().getClassName();
    var container, context;

    if (target && target.className === layerClassName && target.style.opacity === '' && opacity === 1 && (!opt_backgroundColor || target.style.backgroundColor && (0, _array.equals)((0, _color.asArray)(target.style.backgroundColor), (0, _color.asArray)(opt_backgroundColor)))) {
      var canvas = target.firstElementChild;

      if (canvas instanceof HTMLCanvasElement) {
        context = canvas.getContext('2d');
      }
    }

    if (context && context.canvas.style.transform === transform) {
      // Container of the previous layer renderer can be used.
      this.container = target;
      this.context = context;
      this.containerReused = true;
    } else if (this.containerReused) {
      // Previously reused container cannot be used any more.
      this.container = null;
      this.context = null;
      this.containerReused = false;
    }

    if (!this.container) {
      container = document.createElement('div');
      container.className = layerClassName;
      var style = container.style;
      style.position = 'absolute';
      style.width = '100%';
      style.height = '100%';

      if (opt_backgroundColor) {
        style.backgroundColor = opt_backgroundColor;
      }

      context = (0, _dom.createCanvasContext2D)();
      var canvas = context.canvas;
      container.appendChild(canvas);
      style = canvas.style;
      style.position = 'absolute';
      style.left = '0';
      style.transformOrigin = 'top left';
      this.container = container;
      this.context = context;
    }
  };
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */


  CanvasLayerRenderer.prototype.clipUnrotated = function (context, frameState, extent) {
    var topLeft = (0, _extent.getTopLeft)(extent);
    var topRight = (0, _extent.getTopRight)(extent);
    var bottomRight = (0, _extent.getBottomRight)(extent);
    var bottomLeft = (0, _extent.getBottomLeft)(extent);
    (0, _transform.apply)(frameState.coordinateToPixelTransform, topLeft);
    (0, _transform.apply)(frameState.coordinateToPixelTransform, topRight);
    (0, _transform.apply)(frameState.coordinateToPixelTransform, bottomRight);
    (0, _transform.apply)(frameState.coordinateToPixelTransform, bottomLeft);
    var inverted = this.inversePixelTransform;
    (0, _transform.apply)(inverted, topLeft);
    (0, _transform.apply)(inverted, topRight);
    (0, _transform.apply)(inverted, bottomRight);
    (0, _transform.apply)(inverted, bottomLeft);
    context.save();
    context.beginPath();
    context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
    context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
    context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
    context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
    context.clip();
  };
  /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @private
   */


  CanvasLayerRenderer.prototype.dispatchRenderEvent_ = function (type, context, frameState) {
    var layer = this.getLayer();

    if (layer.hasListener(type)) {
      var event_1 = new _Event["default"](type, this.inversePixelTransform, frameState, context);
      layer.dispatchEvent(event_1);
    }
  };
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   */


  CanvasLayerRenderer.prototype.preRender = function (context, frameState) {
    this.frameState = frameState;
    this.dispatchRenderEvent_(_EventType["default"].PRERENDER, context, frameState);
  };
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   */


  CanvasLayerRenderer.prototype.postRender = function (context, frameState) {
    this.dispatchRenderEvent_(_EventType["default"].POSTRENDER, context, frameState);
  };
  /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */


  CanvasLayerRenderer.prototype.getRenderTransform = function (center, resolution, rotation, pixelRatio, width, height, offsetX) {
    var dx1 = width / 2;
    var dy1 = height / 2;
    var sx = pixelRatio / resolution;
    var sy = -sx;
    var dx2 = -center[0] + offsetX;
    var dy2 = -center[1];
    return (0, _transform.compose)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
  };
  /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
   *    location, null will be returned.  If there is data, but pixel values cannot be
   *    returned, and empty array will be returned.
   */


  CanvasLayerRenderer.prototype.getDataAtPixel = function (pixel, frameState, hitTolerance) {
    var renderPixel = (0, _transform.apply)(this.inversePixelTransform, pixel.slice());
    var context = this.context;
    var layer = this.getLayer();
    var layerExtent = layer.getExtent();

    if (layerExtent) {
      var renderCoordinate = (0, _transform.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
      /** get only data inside of the layer extent */

      if (!(0, _extent.containsCoordinate)(layerExtent, renderCoordinate)) {
        return null;
      }
    }

    var x = Math.round(renderPixel[0]);
    var y = Math.round(renderPixel[1]);
    var pixelContext = this.pixelContext_;

    if (!pixelContext) {
      var pixelCanvas = document.createElement('canvas');
      pixelCanvas.width = 1;
      pixelCanvas.height = 1;
      pixelContext = pixelCanvas.getContext('2d');
      this.pixelContext_ = pixelContext;
    }

    pixelContext.clearRect(0, 0, 1, 1);
    var data;

    try {
      pixelContext.drawImage(context.canvas, x, y, 1, 1, 0, 0, 1, 1);
      data = pixelContext.getImageData(0, 0, 1, 1).data;
    } catch (err) {
      if (err.name === 'SecurityError') {
        // tainted canvas, we assume there is data at the given pixel (although there might not be)
        this.pixelContext_ = null;
        return new Uint8Array();
      }

      return data;
    }

    if (data[3] === 0) {
      return null;
    }

    return data;
  };
  /**
   * Clean up.
   */


  CanvasLayerRenderer.prototype.disposeInternal = function () {
    delete this.frameState;

    _super.prototype.disposeInternal.call(this);
  };

  return CanvasLayerRenderer;
}(_Layer["default"]);

var _default = CanvasLayerRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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